import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'bt-estimated-name-modal',
	standalone: false,
	templateUrl: './estimated-name-modal.component.html',
	styleUrl: './estimated-name-modal.component.scss'
})
export class EstimatedNameModalComponent {
	dialogRef = inject(MatDialogRef<EstimatedNameModalComponent>);

	close() {
		this.dialogRef.close();
	}
}
